import { useInView } from 'react-intersection-observer';

import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

import { useWelcomeBannerUBL } from '../log/useWelcomeBannerUBL';

export const useWelcomeBannerService = () => {
  const { bannerImpressionUBL, bannerClickUBL } = useWelcomeBannerUBL();
  const param = useCatalogProductIdParams();
  const {
    product: { first_order_benefit_banner },
    flags: { is_selected_shop },
    key_color: { discount_info_of_atf },
  } = usePdpBaseInfo(param);

  const { ref } = useInView({
    onChange: (inView) => {
      if (inView) {
        bannerImpressionUBL();
      }
    },
    triggerOnce: true,
  });

  const handleClick = () => {
    bannerClickUBL();
    if (first_order_benefit_banner?.landing_url) {
      window.location.assign(first_order_benefit_banner.landing_url);
    }
  };

  return {
    ref,
    backgroundColor: first_order_benefit_banner?.background_color ?? '',
    highlightColor: is_selected_shop ? discount_info_of_atf : undefined,
    title: first_order_benefit_banner?.title ?? '',
    guideText: first_order_benefit_banner?.guide_text ?? '',
    handleClick,
  };
};
